export const DIMENSION_SECTION_ID = "dimension-section";
